import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=6a15ddee&"
import script from "./InfoModal.vue?vue&type=script&lang=js&"
export * from "./InfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a15ddee')) {
      api.createRecord('6a15ddee', component.options)
    } else {
      api.reload('6a15ddee', component.options)
    }
    module.hot.accept("./InfoModal.vue?vue&type=template&id=6a15ddee&", function () {
      api.rerender('6a15ddee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/googleSheet/components/InfoModal.vue"
export default component.exports